/**
 * Page → checker bridge for the per-insurer pages: a package card's "Check
 * Helsana TOP" button selects that package inside the already-mounted
 * `CoverageForm` (same insurer or a switch), which then opens the check-up
 * step. A DOM event rather than lifted state so the page and the form stay
 * decoupled — the form is also embedded on pages that never dispatch it.
 */
export const COVERAGE_PRESELECT_EVENT = "ahead:insurance-preselect"

export interface CoveragePreselectDetail {
  insurerId: string
  packageId: string
}

export function preselectCoveragePackage(detail: CoveragePreselectDetail) {
  window.dispatchEvent(
    new CustomEvent<CoveragePreselectDetail>(COVERAGE_PRESELECT_EVENT, {
      detail,
    })
  )
  document
    .getElementById("coverage-form")
    ?.scrollIntoView({ behavior: "smooth", block: "start" })
}
